/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInputAddress = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 19H2V5h20zM4 17h16V7H4zm14-2h-5v-2h5zm-7 0H6v-2h5zm7-4h-7V9h7zm-9 0H6V9h3z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgInputAddress as InputAddress };
